import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Eyebrow } from './ui/Eyebrow';
export function Testimonials() {
  return <section className="w-full bg-cream" data-id="element-163" data-mp="3fznu5mfudd1w">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-164" data-mp="3fym7ekpgr24c">
        <div className="text-center" data-id="element-165" data-mp="3b0kmdu8h8sq8">
          <Eyebrow data-id="element-166" data-mp="3azjdnwexoibo">Opinie nauczycieli</Eyebrow>
          <h2 className="mt-4 font-display text-[24px] font-bold leading-tight text-ink sm:text-[27px]" data-id="element-167" data-mp="3ayqd5d6kip1z">
            Co mówią polscy pedagodzy
          </h2>
        </div>

        <ul className="mx-auto mt-9 grid max-w-xl gap-4 sm:grid-cols-2" data-id="element-168" data-mp="31ybg5gk8rlin">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-xl border border-sand bg-beige/70 p-5" data-id="element-169" data-mp="2x2w3grxyzvnt">
              <div className="flex gap-0.5" aria-label="Ocena 5 na 5" data-id="element-170" data-mp="v9oqhp5txq53">
                {Array.from({
              length: 5
            }).map((_, starIndex) => <StarIcon key={starIndex} className="h-3 w-3 fill-coral text-coral" aria-hidden="true" data-id="element-171" data-mp="qb54jor8kecq" data-mpi={starIndex} />)}
              </div>

              <blockquote className="mt-3 text-[11px] leading-relaxed text-muted" data-id="element-172" data-mp="77s7jzaq0azt">
                „{item.quote}”
              </blockquote>

              <div className="mt-auto pt-4" data-id="element-173" data-mp="c7wo1pbmp5q1">
                <p className="text-[11px] font-semibold text-ink" data-id="element-174" data-mp="c8ol74kvjbif">
                  {item.name}
                </p>
                <p className="text-[10px] text-muted/80" data-id="element-175" data-mp="14v9ck51cnnlz">{item.role}</p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-[9px] text-muted/70" data-id="element-176" data-mp="q5lbn4x2yqys">
          Opinie z ankiety wśród nauczycieli plastyki, 2025.
        </p>
      </div>
    </section>;
}